/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { AddUpdateSports } from "../../sub-modules"
import { GetSportsDetails, UpdateSport } from "../../utilities/api/sports/indext"
import { RuleType } from "../../utilities/types"
import { ToastContainer, toast } from "react-toastify"

const UpdateSports = () => {
    const location = useLocation()
    let id = location.state
    const navigate = useNavigate()
    const [ruleCount, setRuleCount] = useState(1);
    const [rules, setRules] = useState<RuleType[]>([{ subject: "", description: "" }])
    const [status, setStatus] = useState("")
    const [sportName, setSportName] = useState("")
    const [image, setImage] = useState<any>("")
    const [submitButton, setSubmitButton] = useState(false)

    const handleCreateUpdate = async (payload: any) => {
        setSubmitButton(true)
        const result = await UpdateSport(id, payload)
        if (result.status === 200) {
            navigate("/sports")
        }
        else {
            toast.error(result.response.data.message);
        }
        setSubmitButton(false)
    }

    const GetInfo = async () => {
        const result = await GetSportsDetails(id)
        if (result.statusCode === 200) {
            setSportName(result.data.name)
            setRuleCount(result.data.sportRules.length)
            setStatus(result.data.isActive as string)
            setImage(result.data.image)
            setRules(result.data.sportRules.map((item: any) => {
                return {
                    id: item.id,
                    ruleId: item.ruleId,
                    subject: item.rule.subject,
                    description: item.rule.description,
                }
            }))
        } else {
            toast.error(result.response.data.message);
        }
    }

    useEffect(() => {
        GetInfo()
    }, [])

    return (
        <>
            <AddUpdateSports submitButton={submitButton} id={id} sportName={sportName} setSportName={setSportName} status={status} setStatus={setStatus} name="Edit Sport" rules={rules} setRules={setRules} ruleCount={ruleCount} setRuleCount={setRuleCount} handleCreateUpdate={handleCreateUpdate} key={"update-sport-status-" + status} setImage={setImage} image={image} />
            <ToastContainer />
        </>
    )
}

export { UpdateSports }
